
import { LINKS } from '../constants';
import axios from 'axios';

export class Http {

  constructor() {
    this.axios = axios.create({ baseURL: LINKS.api });
  }

  static getIntance() {
    if (Http._instance) {
      return Http._instance;
    }
    return (this._instance = new Http());
  }

  transformResponse(response) {
    return response.then(e => e.data);
  }

  postToAPI(route, params) {
    return this.transformResponse(this.axios.post(route, params));
  }
}

export const httpService = Http.getIntance();